(ns com.theplantscape.plant-web.pages.main
  (:require
   [clojure.core.async :refer [<! go]]
   [com.theplantscape.web-ui.tailwind.ensemble :refer [ui-stat-tile]]
   [com.theplantscape.plant-web.api.site :refer [api-fetch-site-stats]]
   [com.theplantscape.plant-web.draw.state :refer [app-state site-state]]
   [com.theplantscape.plant-web.components.search :refer [ui-plant-search]]
   [com.theplantscape.plant-web.components.tiles :refer [fa-icon ui-simple-icon simple-tile-container simple-tile]]
   [com.theplantscape.plant-web.components.hero :refer [hero-style-01]]
   [com.theplantscape.web-ui.tailwind.buttons :refer [ui-btn-link]]

   [com.theplantscape.plant-web.pages.plant-layouts :refer [change-page]]
   [com.theplantscape.web-ui.tailwind.banner :as banner]
   [reitit.frontend.easy :as rfe]))

(defn api-handler-response [handler [state payload]]
  (if state
    (handler payload)
    (do
      (handler nil)
      (case (:status payload)
        401 (do (prn "401 unauth")
                (swap! site-state assoc :auth nil))))))

(defn init-main-page [_]
  (go (api-handler-response
       (partial swap! app-state assoc-in [:page :homepage])
       (<! (api-fetch-site-stats)))))

(defn head [path-params]
  {:mh-head [:title "The Plantscape - Garden design"]
   :mh-og-title [:meta {"property" "og:title" "content" "The Plantscape - Garden design"}]
   :mh-og-url [:meta {"property" "og:url" "content" "https://theplantscape.com"}]
   :mh-og-type [:meta {"property" "og:type" "content" "website"}]
   :mh-og-description [:meta {"property" "og:description" "content" "Design your garden or natural space, create plant groupings (polycultures) and track your plants growing flowering fruiting and harvesting schedule's"}]
   :mh-og-image [:meta {"property" "og:image" "content" "https://img.theplantscape.com/api/image/pf/default.png?p=large"}]
   :mh-description [:meta {"name" "description" "content" "Design your garden or natural space, create plant groupings (polycultures) and track your plants growing flowering fruiting and harvesting schedule's"}]
   :mh-keywords [:meta {"name" "keywords"}]
   :mh-robots [:meta {"name" "robots"} "index, follow"]})

(defn page-homepage [path]
  [:<>
   [:div

    [hero-style-01
     {:title "Design your plantscape"
      :description "Design, Organise and iterate your garden"
      :image "/images/hero/hero-01.png"
      :call-to-action-link (rfe/href :diagrams)
      :call-to-action-text "Explore user designs"
      :body [:div
             [ui-btn-link {:href (rfe/href :plant-lists) :text "Build List"}]
             [ui-btn-link {:href (rfe/href :diagrams) :text "Start Designing"}]]}]

    [:div.m-4 
     [:div.bg-teal-500.rounded-lg
      [ui-plant-search change-page]]

                                        ;[:h3 "Get started"]
     [simple-tile-container 
      [
       [simple-tile
        {:title "Design"
         :image [fa-icon "fa-compass-drafting"]
         :link (rfe/href :diagrams)
         :description "Landscape plant layout"}]
       [simple-tile
        {:title "Polyculture"
         :image [fa-icon "fa-circle-nodes"]
         :link (rfe/href :polycultures)
         :description "Create a plant companion group"}]
       [simple-tile
        {:title "Plant lists"
         :image [fa-icon "fa-list"]
         :href (rfe/href :plant-lists)
         :description "Plant selection"}]

       #_[ui-simple-icon
          {:title "Design"
           :icon "fa-compass-drafting"
           :href (rfe/href :diagrams)
           :alt "Design"
           :description "Landscape plant layout"}]
       #_[ui-simple-icon
          {:title "Polyculture"
           :icon "fa-circle-nodes"
           :href (rfe/href :polycultures)
           :alt "Plant grouping"
           :description "Create a plant companion group"}]
       #_[ui-simple-icon
          {:title "Plant calendar"
           :icon "fa-calendar"
           :href (rfe/href :schedule)
           :alt "Plant life cycle events"
           :description "Plant schedule"}]
       #_[ui-simple-icon
          {:title "Plant lists"
           :icon "fa-list"
           :href (rfe/href :plant-lists)
           :description "Plant selection"}]]]

     [:div.mt-8.flex.flex-wrap.justify-center.items-center.gap-4
      [ui-stat-tile
       {:icon [:i.fa-solid.fa-user]
        :value (-> @app-state :page :homepage :users)
        :text "Users"}]
      [ui-stat-tile
       {:icon [:i.fa-solid.fa-leaf]
        :value (-> @app-state :page :homepage :plants)
        :text "Plants"}]
      [ui-stat-tile
       {:icon [:i.fa-solid.fa-atom]
        :value (-> @app-state :page :homepage :polycultures)
        :text "Polycultures"}]
      [ui-stat-tile
       {:icon [:i.fa-solid.fa-pencil]
        :value (-> @app-state :page :homepage :designs)
        :text "Diagrams"}]]]]])
